import type { SelectedItemRenderProps } from '@openx/components-core/lib/SelectionDrawer/types';
import { SelectedContextualSegmentItem, type SelectedSegmentWithMode } from './SelectedContextualSegmentItem';

export const SelectedContextualSegmentItemDisplay = (props: SelectedItemRenderProps<SelectedSegmentWithMode>) => (
  <SelectedContextualSegmentItem {...props} wrapText hideRemoveUntilHover />
);
